import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

// Credit Note is an invoice with any of positions amount < 0
export const CreditNote = 'credit_note' as const;
export type CreditNote = typeof CreditNote;
export type ConvertableTypes = Entities | CreditNote;
